import { render, staticRenderFns } from "./PlaceAutocomplete.vue?vue&type=template&id=6053de58&scoped=true&"
import script from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAutocomplete.vue?vue&type=style&index=0&id=6053de58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053de58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
